import { render, staticRenderFns } from "./EgiftPayment.vue?vue&type=template&id=285483da&"
import script from "./EgiftPayment.vue?vue&type=script&lang=js&"
export * from "./EgiftPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports